import { jsx as _jsx } from "react/jsx-runtime";
export const TabMenuWrapper = props => {
    return (_jsx("ul", Object.assign({ className: props.classNameOverride ? props.classNameOverride : 'nav nav-tabs nav-tabs-' + props.variant }, { children: props.children })));
};
